import { type z } from 'zod'
import { unique } from '../../util/array'
import { ViewIdSchema } from './model'

export const MAX_VIEW_COUNT = 10_000

export const ViewOrderSchema = ViewIdSchema.array()
  .max(MAX_VIEW_COUNT)
  .refine((viewIds) => unique(viewIds).length === viewIds.length, 'View order must contain unique IDs')
export type ViewOrder = z.infer<typeof ViewOrderSchema>
